import React, { Fragment, useEffect, useRef, useState } from "react";
import MyCard from "../../tools/MyCard";
import { Copy, Eye, Image, Trash2, Upload } from "lucide-react";
import { SolidButton } from "../../global/SolidButton";
import { MyModal } from "../../global/MyModal";
import toast from "react-hot-toast";
import { deleteImages, getImages, uploadImage } from "../apps_manage/api";
import MyLoader from "../../util/MyLoader";

export default function Images() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [image, setImage] = useState("");
  const fileInputRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [name, setName] = useState("");
  const [bucket, setBucket] = useState("icons");
  const [folder, setFolder] = useState("avatars");
  const [url, setUrl] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [file, setFile] = useState(null);

  const buckets = ["icons", "logos", "images"];
  const folders = ["avatars", "banners", "gateways","games", "social", "thumbnails"];

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("URL copied to clipboard");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
        toast.error("Failed to copy URL");
      });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/svg+xml"];

    if (!allowedTypes.includes(selectedFile.type)) {
      toast("Only PNG, JPG, JPEG, SVG files are allowed");
      return;
    }

    if (selectedFile.size > 2 * 1024 * 1024) {
      toast("File size must be less than 2MB");
      return;
    }

    // setFileSize(formatFileSize(selectedFile.size));
    setFile(selectedFile); // ✅ store actual file

    const reader = new FileReader();

    reader.onload = async () => {
      //hit api for upload image

      try {
        // const repTxt = name.replace(/\s+/g, "_");
        // const res = await uploadAvatar({
        //   userName: repTxt,
        //   file: file,
        // });
        // const data = res?.data;
        // if (data.success) {
        //   setAvatar(data.url);
        // }

        setImage(reader.result);
        setIsModalOpen(true);
      } catch (err) {
        console.error(err);
      }
    };

    reader.readAsDataURL(selectedFile); // ✅ FIXED
  };

  // const handleKeyDown = (e) => {
  //   if (e.key === "Backspace") {
  //     setName(""); // clear text
  //     makeUrl();
  //   }
  // };

  useEffect(() => {
    if (!name) {
      setUrl(null);
      return;
    }

    const name_ = name.replace(/\s+/g, "_").toLowerCase();
    const bucket_ = bucket.replace(/\s+/g, "_").toLowerCase();
    const folder_ = folder.replace(/\s+/g, "_").toLowerCase();
    const myPath =
      "https://media.adwave.in/" +
      bucket_ +
      "/" +
      folder_ +
      "/" +
      name_ +
      ".jpg";
    setUrl(myPath);
  }, [name, bucket, folder]);

  const fetchImages = async () => {
    //hit api to fetch images
    try {
      const res = await getImages();
      const data = res?.data;
      if (data.success) {
        setImages(data.data);
      }
    } catch (err) {
      toast.error("Failed to fetch images");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchImages();
  }, []);

  const handleDelete = async () => {
    try {
      const res = await deleteImages(deleteId);
      if (res?.status === 200) {
        toast.success("Image deleted successfully");
        // refresh list
        fetchImages();
      }
    } catch (err) {
      console.error("Failed to delete image", err);
      toast.error(err.response?.data?.error || "Failed to delete image");
    }
    setDeleteId(null);
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!validateForm()) return;

    // hit api to upload image
    try {
      const res = await uploadImage({ folder, bucket, name, file });
      const data = res?.data;
      if (data.success) {
        toast.success("Image uploaded successfully");
        setIsModalOpen(false);
        fetchImages();
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to upload image");
    }
  };

  const validateForm = () => {
    const errs = {};

    //bucket  validation
    if (!bucket.trim()) {
      errs.bucket = "bucket  is required";
    }
    //folder validation
    if (!folder || !folder.trim()) {
      errs.folder = "Folder is required";
    }
    //name title validation
    if (!name || !name.trim()) {
      errs.name = "Name is required";
    }

    setErrors(errs);
    console.log("click to submit:" + errors.bucket);

    return Object.keys(errs).length === 0;
  };
  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-2  flex  flex-col items-center justify-between mx-10 ">
        <div className=" w-full relative">
          <MyCard className="p-4 flex items-center justify-start space-x-2  w-full ">
            <Upload
              size={38}
              className="text-white bg-gray-400 dark:bg-gray-500 p-2 rounded-lg"
            />
            <div className="flex flex-col items-start justify-start">
              <span className="text-sm text-slate-800 dark:text-slate-200 font-semibold ">
                Click to upload or drag and drop
              </span>
              <span className="text-xs text-slate-800 dark:text-slate-400 font-normal ">
                PNG,JPG,GIF,SVG up to 5MB
              </span>
            </div>
            <SolidButton className="ml-auto">
              <Upload size={16} className="text-white" />
              <span className="text-sm text-white">Browse</span>
            </SolidButton>

            <input
              accept=".png,.jpg,.jpeg,.svg"
              ref={fileInputRef}
              onChange={handleFileChange}
              type="file"
              className="absolute bg-amber-400 inset-0 w-full  opacity-0 h-full cursor-pointer "
            />
          </MyCard>
        </div>
        {/* no data */}
        {images.length === 0 && (
          <div className="flex flex-col items-center justify-center space-y-2 mt-50">
            <Image
              size={45}
              className="p-2 rounded-full dark:text-gray-400 bg-slate-300/80 text-slate-500 dark:bg-slate-700/80"
            />
            <span className="text-slate-500 dark:text-slate-100 font-medium text-sm">
              No Images uploaded yet
            </span>
            <span className="text-slate-500 dark:text-slate-400 font-normal text-xs">
              upload your first image to get started
            </span>
          </div>
        )}

        <table className="min-w-full  mt-10">
          <thead>
            <tr className="bg-slate-100 dark:bg-slate-800/60 border-t border-slate-300 dark:border-slate-700">
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 ps-4 py-3 ">
                ID
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                Image
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                Name
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                Path
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                Bucket
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                Folder
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 pe-4">
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {images.map((img) => (
              <tr
                key={img.id}
                className="hover:bg-slate-100 dark:hover:bg-gray-800/20 border-b border-slate-300/40 "
              >
                <td className="text-start text-xs text-slate-800 font-normal dark:text-slate-300 ps-4 py-3 ">
                  {"#" + img.id}
                </td>
                <td className="text-start text-xs text-slate-800 font-normal font-sans dark:text-slate-300 py-3">
                  <div
                    onClick={() => {
                      setZoomedImage(img.url);
                    }}
                    className="w-18 h-10 overflow-hidden rounded-md "
                  >
                    <img
                      src={img.url}
                      alt={img.name}
                      className="w-full h-full object-cover cursor-pointer transition-transform duration-300 ease-in-out hover:scale-125"
                    />
                  </div>
                </td>
                <td className="text-start text-xs text-slate-800 font-normal font-sans dark:text-slate-300 py-3">
                  {img.name}
                </td>
                <td className=" text-start text-xs text-slate-800 font-normal font-sans dark:text-slate-300 py-3">
                  <div className="flex items-center justify-start space-x-1">
                    <span className="max-w-60 overflow-auto text-ellipsis">
                      {" "}
                      {img.url}
                    </span>
                    <Copy
                      size={16}
                      onClick={() => handleCopy(img.url)}
                      className="text-center text-blue-500 cursor-pointer ml-2"
                    />
                  </div>
                </td>
                <td className="text-start text-xs text-slate-800 font-normal font-sans dark:text-slate-300 py-3">
                  {img.bucket}
                </td>
                <td className="text-start text-xs text-slate-800 font-normal font-sans dark:text-slate-300 py-3">
                  {img.folder}
                </td>
                <td className="text-end text-xs text-slate-800 font-normal font-sans dark:text-slate-300 py-3 ">
                  <Trash2
                    size={16}
                    onClick={() => setDeleteId(img.id)}
                    className="text-center text-red-500 cursor-pointer"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <MyModal
        title={"Upload Image"}
        icon={Upload}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <div className="flex flex-col items-start justify-center">
          <div className="flex items-center justify-center w-full mt-6">
            <img
              className="min-w-auto h-50 p-2 border border-dotted   dark:border-slate-400 border-slate-500 rounded-lg "
              src={image}
              alt=""
            />
          </div>

          {url && (
            <span className="text-xs dark:text-slate-400 text-slate-300 mt-4 font-medium font-sans">
              {"URL : " + url}
            </span>
          )}

          {/* bucket */}
          <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-4 ">
            Bucket*
          </h1>

          <select
            name="bucket"
            value={bucket}
            onChange={(e) => {
              setBucket(e.target.value);
              if (errors.bucket)
                setErrors((prev) => ({ ...prev, bucket: undefined }));
            }}
            //  onKeyDown={handleKeyDown}
            placeholder="Enter bucket"
            className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${
                errors.bucket
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
          >
            {buckets.map((bkt) => (
              <option key={bkt} value={bkt}>
                {bkt}
              </option>
            ))}
          </select>
          {errors.bucket && (
            <span className="text-xs text-red-500 mt-1">{errors.bucket}</span>
          )}
          {/* folder */}
          <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-4 ">
            Folder*
          </h1>
          <select
            name="folder"
            value={folder}
            onChange={(e) => {
              setFolder(e.target.value);
              if (errors.folder)
                setErrors((prev) => ({ ...prev, folder: undefined }));
            }}
            //  onKeyDown={handleKeyDown}
            placeholder="Enter folder"
            id=""
            className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${
                errors.folder
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
          >
            {folders.map((fld) => (
              <option key={fld} value={fld}>
                {fld}
              </option>
            ))}
          </select>
          {errors.folder && (
            <span className="text-xs text-red-500 mt-1">{errors.folder}</span>
          )}
          {/* Image Name */}
          <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-4 ">
            Image Name*
          </h1>
          <input
            type="text"
            name="image name"
            value={name}
            maxLength={16}
            onChange={(e) => {
              setName(e.target.value);
              if (errors.name)
                setErrors((prev) => ({ ...prev, name: undefined }));
            }}
            //  onKeyDown={handleKeyDown}
            placeholder="Enter Image Name"
            id=""
            className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${
                errors.name
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
          />
          {errors.name && (
            <span className="text-xs text-red-500 mt-1">{errors.name}</span>
          )}
          {/*  */}
          <div className="flex items-center justify-end space-x-4 mt-4 ml-auto">
            <button
              className="px-4 py-2 rounded-lg
                       bg-slate-400/20 dark:bg-slate-800 
                       text-slate-800 dark:text-slate-300 text-sm font-semibold
                       hover:bg-slate-400/30 dark:hover:bg-slate-700 
                       transition-all duration-300 "
              onClick={() => {
                setIsModalOpen(false);
              }}
            >
              Cancel
            </button>
            <SolidButton
              children={<span className="capitalize">upload</span>}
              onClick={(e) => handleSubmit(e)}
            />
          </div>
        </div>
      </MyModal>
      {/* Zoomed image */}
      <MyModal
        title={"Image Preview"}
        icon={Eye}
        isOpen={zoomedImage !== null}
        onClose={() => setZoomedImage(null)}
      >
        <div className="flex flex-col items-start justify-center">
          <div className="flex items-center justify-center w-full mt-6">
            <img
              className="min-w-auto h-60 p-2 border border-dotted   dark:border-slate-400 border-slate-500 rounded-lg "
              src={zoomedImage}
              alt=""
            />
          </div>
        </div>
      </MyModal>
      {/* DELETE CONFIRM MODAL */}
      <MyModal
        isOpen={!!deleteId}
        title="Delete Image?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this image?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={handleDelete} children={<span>Delete</span>} />
        </div>
      </MyModal>
    </Fragment>
  );
}
